import 'css-chunksrc/client/pages/projectPage/exportsPage/timesheetByTaskReport/styles.scss';export default {
  "wbsReport": "_wbsReport_1hvof_1",
  "checked": "_checked_1hvof_7",
  "row": "_row_1hvof_11",
  "checkbox": "_checkbox_1hvof_20",
  "col": "_col_1hvof_26",
  "name": "_name_1hvof_30",
  "description": "_description_1hvof_37",
  "filters": "_filters_1hvof_42",
  "group": "_group_1hvof_51",
  "label": "_label_1hvof_60",
  "button": "_button_1hvof_67",
  "integrationDateFilterInput": "_integrationDateFilterInput_1hvof_71",
  "integrationDateFilterTypeName": "_integrationDateFilterTypeName_1hvof_78"
};